export const NOTICES_COMBOS_IDS = [
  'roles_all',
  'cod_zona_zeus',
  'tags_avisos',
]
